import { Progress, Upload, message } from 'antd';
import { UploadFile, UploadProps } from 'antd/lib/upload';
import { FC, useEffect, useState } from 'react';
import {
  ACTION,
  DEFAULT_ACCEPT,
  EXCEL_TYPES,
  FILE_TYPES,
  SIZE100MB,
  geneHeaders,
} from '../const';

import { RcFile } from 'antd/es/upload';
import { getResolvedSrc } from '../utils';

export type IProps = {
  value?: UploadFile[];
  onChange?: (value: UploadFile[]) => void;
  module?: string;
} & Omit<UploadProps, 'onChange'>;

export const FileUploader: FC<IProps> = (props) => {
  const {
    value = [],
    onChange,
    action = ACTION,
    maxCount = 1,
    module = '',
    accept: defaultAccept,
    headers = geneHeaders(),
    ...restProps
  } = props;

  const [accept, setAccept] = useState<string>('');

  useEffect(() => {
    if (defaultAccept) {
      setAccept(defaultAccept);
      return;
    }
    if (module === 'FINANCIAL_ANALYSIS') {
      setAccept([...FILE_TYPES, ...EXCEL_TYPES].join(','));
    } else {
      setAccept(DEFAULT_ACCEPT);
    }
  }, [module, defaultAccept]);

  const onChangeFile = (value: {
    file: UploadFile;
    fileList: UploadFile[];
  }) => {
    const { file, fileList } = value;
    if (file.response && file.response.code !== 0) {
      message.error(file.response.msg);
    }
    onChange?.(fileList);
  };

  const beforeUpload = (file: RcFile) => {
    if (file.size > SIZE100MB) {
      message.error('文件大小不得超过100M');
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  return (
    <div className="flex items-center w-full h-14 px-4 py-2.5 bg-selected rounded hover:bg-[#F0F3FA]">
      <img
        width={36}
        height={36}
        className="mr-3"
        src={getResolvedSrc(value[0]?.name || '')}
      ></img>
      <div className="flex flex-col flex-1 h-full ">
        <div className="flex flex-1  justify-between items-center">
          <span
            className={`flex-1 w-0  mr-3 text-sm truncate ${
              value[0]?.error ? 'text-error' : 'text-secondary-1'
            }`}
          >
            {value.length > 0 ? value[0].name : ''}
          </span>
          <Upload
            headers={headers}
            {...restProps}
            accept={accept}
            beforeUpload={beforeUpload}
            maxCount={maxCount}
            action={action}
            fileList={value}
            onChange={onChangeFile}
            showUploadList={false}
          >
            <button className="text-xs text-primary" type="button">
              重新上传
            </button>
          </Upload>
        </div>
        {value[0]?.status === 'uploading' && (
          <Progress
            type="line"
            size="small"
            showInfo={false}
            percent={value.length > 0 ? value[0].percent : 0}
            strokeWidth={3}
            strokeColor={{ '0%': '#76A4FF', '100%': '#8587FF' }}
          />
        )}
      </div>
    </div>
  );
};
